import { render, staticRenderFns } from "./AssetCompany.vue?vue&type=template&id=062ae894&scoped=true"
import script from "./AssetCompany.vue?vue&type=script&lang=js"
export * from "./AssetCompany.vue?vue&type=script&lang=js"
import style0 from "./AssetCompany.vue?vue&type=style&index=0&id=062ae894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062ae894",
  null
  
)

export default component.exports